"use strict";
jQuery(document).foundation();
